import React, { useState, useEffect, useRef }   from "react";
import { useNavigate }                          from "react-router-dom";
import BtnChangeTheme                           from "components/Buttons/Theme/BtnTheme";
import {useActionModal}                         from "components/Covers/confirmAction";
import {getUserTag}                             from "./menuService";
import { funGame, getImgSrc }                   from "Utilities/utils";
import {useInfoMsgModal}                        from "components/Covers/infoMessageModal";
import MainStyle                                from 'components/UI/main.module.scss';
import LocalStyle                               from './menu.module.scss';
import logo                                     from "assets/logo-header.png";
import {  Heimdall, GetLabel, SetAppLang  }     from "Utilities/utils";

let appLang = null;

// This will manage the state globally
// this component render contents of menu displayed by another
// jsx component and displays the component and the information about
// the component
let showFilterMenuCallback = null;
let hideFilterMenuCallback = null;
let showMenuCallback       = null;
let hideMenuCallback       = null;

export const useFilter = () => {
  return { showFilter: showFilterMenuCallback, hideFilter:  hideFilterMenuCallback};
};
export const useMenu = () => {
  return { showMenu: showMenuCallback, hideMenu:  hideMenuCallback};
};

export const FilterComponent = () => {
  const [mounted,   setMounted    ]  = useState(false);
  const [isOpen,    setIsOpen     ]  = useState(false);
  const [jsx,       setJsx        ]  = useState(<></>);
  const [isSliding, setIsSliding  ]  = useState(true);  // slide animation

  showFilterMenuCallback = ({ jsx }) => {
    setJsx(jsx);
    setMounted(true);
  };

  hideFilterMenuCallback = () => setMounted(false);

  const sidebarClass = [
    isOpen ? MainStyle.sidebar_expanded_filter : MainStyle.sidebar_retracted_filter,
    isSliding ? MainStyle.slide_out_filter : MainStyle.slide_in_filter  
  ].join(" ");

  const openPanel = () => {
    setIsSliding(false);
    setTimeout(() => setIsSliding(true), 100); // Show content after sliding
    setTimeout(() => setIsOpen(true), 101);
  };
  
  // Function to close menu with animation
  const closePanel = () => {
    setIsSliding(false);
    setTimeout(() => setIsSliding(true), 100); // Show content after sliding
    setTimeout(() => setIsOpen(false), 101);
  };

  const togglePanel = () => {
    if (!isOpen) {     
      openPanel(); 
    } 
    else {
      closePanel();
    }
  };

  return (
    <>
      {mounted ? (
            <>
            <div className={sidebarClass}>
              {isOpen ?
                <>
                  <div className={[MainStyle.mt_2, MainStyle.border_bottom].join(" ")}></div>

                  <div className={[MainStyle.row, MainStyle.sidebar_btn_menu, MainStyle.py_2].join(" ")} onClick={() => {togglePanel();}}>
                    <div className={MainStyle.col_2}>
                      <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_middle].join(" ")}>
                        <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            viewBox="0 0 448 512"
                            className={MainStyle.sidebar_ico_chevron}
                        >
                          <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/>
                        </svg>                     
                      </div>              
                    </div>
                    <div className={MainStyle.col_10}>
                      <div className={[MainStyle.text_start].join(" ")}>
                        <span className={[MainStyle.fs_6, MainStyle.text_body].join(" ")}>{GetLabel(appLang, 168)}</span>
                      </div>
                    </div>
                  </div>

                  <div className={[MainStyle.mb_2, MainStyle.border_bottom].join(" ")}></div>


                  <div className={MainStyle.mt_3}></div>
                    {jsx}
                </>
              :
                <div className={[MainStyle.container, MainStyle.my_1, MainStyle.mx_1].join(" ")}>
                  <button                 
                      className={[MainStyle.menu_widget_btn, 
                                  MainStyle.rounded_2, 
                                  MainStyle.border, 
                                  MainStyle.shadow_sm].join(" ")}
                      onClick={() => {togglePanel();}}
                  >
                    <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_items_center, MainStyle.my_1].join(" ")}>
                      <svg 
                          xmlns="http://www.w3.org/2000/svg" 
                          viewBox="-150 -150 800 800"
                          className={MainStyle.sidebar_btn}
                      >
                          <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                      </svg>
                    </div>
                  </button>
                </div>
              }
            </div>
             { isOpen ? <div style={{zIndex: 99}}className={[MainStyle.loading_cover].join(" ")} onClick={() => togglePanel()}></div> : null }
            </>
      ) : null}
    </>
  );
};

function getLastFeatureBlock({refArr, clickAction}){
  let f   = localStorage.getItem("last_feature");
  if (f) {
    let founded = refArr.find((i) => i === parseInt(f))
    if (founded) {
      clickAction();
    }
  }
}
function getLastTagFeatureBlock({clickAction}) {
  let f   = localStorage.getItem("last_feature");
  if (f) {
    if ( parseInt(f) >= 1000 && parseInt(f) < 9999) {
      clickAction();
    }
  }
}

const Tag = React.memo(({ tagId, tagColor, tagDesc, toggleMenu }) => {
  const navigate = useNavigate();
  const {hideFilter}  = useFilter();
  
  const IsCurrent = () => {
    let data = localStorage.getItem("last_feature");
    if (data) {
      return (parseInt(data) === (1000 + parseInt(tagId)) ? true : false);
    }
    return false;
  };
  return (
    <div 
        id={tagId} 
        className={[MainStyle.row, 
                    MainStyle.clickable, 
                    MainStyle.p_2,
                    IsCurrent() ? MainStyle.btn_green : MainStyle.sidebar_btn_menu_items,].join(" ")}
        onClick={() => {hideFilter(); navigate(`/tag/${tagId}`); toggleMenu();}}
    >
      <div className={MainStyle.col_2}>
        <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_middle].join(" ")}>
          <svg 
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 448 512"
              className={MainStyle.sidebar_btn_ico_tag_generic}
              style={{ fill: tagColor }}
          >
            <path d="M0 80L0 229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7L48 32C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/>
          </svg>
        </div>              
      </div>
      <div className={MainStyle.col_10}>
        <div className={[MainStyle.text_start].join(" ")}>
          <span className={[MainStyle.fs_6, IsCurrent() ? MainStyle.text_white : null].join(" ")}>{tagDesc}</span>
        </div>
      </div>            
    </div>
  );
});

const TagManager = React.memo(({ toggleMenu }) => {
  const navigate = useNavigate();
  const {hideFilter}  = useFilter();
  const IsCurrent = () => {
    let data = localStorage.getItem("last_feature");
    if (data) {
      return (parseInt(data) === 1000 ? true : false);
    }
    return false;
  };

  return(
    <div className={[ MainStyle.row, 
                      MainStyle.clickable, 
                      MainStyle.p_2,
                      IsCurrent() ? MainStyle.btn_green : MainStyle.sidebar_btn_menu_items,].join(" ")}
          onClick={() => {
                  hideFilter(); 
                  navigate(`/user_tags`); 
                  toggleMenu();
          }}
    >
      <div className={MainStyle.col_2}>
        <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_middle].join(" ")}>
          <svg style={{fill: 'rgb(216, 17, 89)', width: 'auto', height: '1.25rem', margin: '0.15rem'}}
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 640 640"
          >
            <path d="M259.1 73.5C262.1 58.7 275.2 48 290.4 48L350.2 48C365.4 48 378.5 58.7 381.5 73.5L396 143.5C410.1 149.5 423.3 157.2 435.3 166.3L503.1 143.8C517.5 139 533.3 145 540.9 158.2L570.8 210C578.4 223.2 575.7 239.8 564.3 249.9L511 297.3C511.9 304.7 512.3 312.3 512.3 320C512.3 327.7 511.8 335.3 511 342.7L564.4 390.2C575.8 400.3 578.4 417 570.9 430.1L541 481.9C533.4 495 517.6 501.1 503.2 496.3L435.4 473.8C423.3 482.9 410.1 490.5 396.1 496.6L381.7 566.5C378.6 581.4 365.5 592 350.4 592L290.6 592C275.4 592 262.3 581.3 259.3 566.5L244.9 496.6C230.8 490.6 217.7 482.9 205.6 473.8L137.5 496.3C123.1 501.1 107.3 495.1 99.7 481.9L69.8 430.1C62.2 416.9 64.9 400.3 76.3 390.2L129.7 342.7C128.8 335.3 128.4 327.7 128.4 320C128.4 312.3 128.9 304.7 129.7 297.3L76.3 249.8C64.9 239.7 62.3 223 69.8 209.9L99.7 158.1C107.3 144.9 123.1 138.9 137.5 143.7L205.3 166.2C217.4 157.1 230.6 149.5 244.6 143.4L259.1 73.5zM320.3 400C364.5 399.8 400.2 363.9 400 319.7C399.8 275.5 363.9 239.8 319.7 240C275.5 240.2 239.8 276.1 240 320.3C240.2 364.5 276.1 400.2 320.3 400z"/>
          </svg>
        </div>              
      </div>
      <div className={MainStyle.col_10}>
        <div className={[MainStyle.text_start].join(" ")}>
          <span className={[MainStyle.fs_6, IsCurrent() ? MainStyle.text_white : null].join(" ")}>
            {GetLabel(appLang, 579)}
          </span>
        </div>
      </div>            
    </div>
  );
});

const Feature = React.memo(({ objKey, ifeature, toggleMenu }) => {
  const navigate                = useNavigate();
  const {hideFilter}            = useFilter();

  let obj = {
    'desc': '',
    'path': ''
  };
  switch(ifeature) {
    case 1: 
      obj.desc = GetLabel(appLang, 81);
      obj.path = "users";
      break;
    case 2: 
      obj.desc = GetLabel(appLang, 85);
      obj.path = "sectors";
      break;      
    case 3: 
      obj.desc = GetLabel(appLang, 73);
      obj.path = "teaching_structure";
      break;
    case 4:
      obj.desc = GetLabel(appLang, 89);
      obj.path = "footers";
      break;
    case 5:
      obj.desc = GetLabel(appLang, 82);
      obj.path = "profile_photo";
      break;
    case 6:
      obj.desc = GetLabel(appLang, 72);
      obj.path = "logos";
      break;
    case 7:
      obj.desc = GetLabel(appLang, 87);
      obj.path = "colors";
      break;     
    case 8:
      obj.desc = GetLabel(appLang, 80);
      obj.path = "option_lists";
      break;    
    case 9:
      obj.desc = GetLabel(appLang, 79);
      obj.path = "questions";
      break;
    case 10:
      obj.desc = GetLabel(appLang, 78);
      obj.path = "patterns";
      break;
    case 11:
      obj.desc = GetLabel(appLang, 71);
      obj.path = "orders_closed";
      break;
    case 12:
      obj.desc = GetLabel(appLang, 75);
      obj.path = "report_0";
      break;
    case 13:
      obj.desc = GetLabel(appLang, 70);
      obj.path = "orders_ready";
      break;      
    case 14:
      obj.desc = GetLabel(appLang, 69);
      obj.path = "orders";
      break;      
    case 15:
      obj.desc = GetLabel(appLang, 561);
      obj.path = "company_position";
      break;
    case 16:
      obj.desc = GetLabel(appLang, 84);
      obj.path = "designation";
      break;
    case 17:
      obj.desc = GetLabel(appLang, 88);
      obj.path = "slides";
      break;
    case 18:
      obj.desc = GetLabel(appLang, 76);
      obj.path = "report_1";
      break;
    case 19:
      obj.desc = GetLabel(appLang, 77);
      obj.path = "report_2";
      break;      
    case 22:
      obj.desc = GetLabel(appLang, 590);
      obj.path = "report_4";
      break;
    case 23:
      obj.desc = GetLabel(appLang, 623);
      obj.path = "report_6";
      break;                
    case 24:
      obj.desc = GetLabel(appLang, 624);
      obj.path = "report_7";
      break;                        
    case 200:
      obj.desc = GetLabel(appLang, 74);
      obj.path = "image_resizer";
      break;                  
    case 9999:
      obj.desc = GetLabel(appLang, 581);
      obj.path = "report_3";
      break;                  
    default:
      obj.desc = "";
      obj.path = "/";
      break;
  }
  function clickHandler () {
      switch(ifeature) {
        case 12:
          break;            
        case 13:
          break;
        case 14:
          break;
        case 11:
          break;            
        default:
          hideFilter(); 
          break;
      }
      if (window.location.pathname !== `/${obj.path}`) {
        navigate(`/${obj.path}`);
        toggleMenu();
        //showActionMessage(
        //  { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 562)}<br/>{GetLabel(appLang, 103)}</> },
        //  { confirm_action: () => {
        //                navigate(`/${obj.path}`);
        //                toggleMenu();
        //  }}
        //);
      }
      else {
        return;
      }
  }
  const IsCurrent = () => {
    let data = localStorage.getItem("last_feature");
    if (data) {
      return (parseInt(data) == ifeature ? true : false);
    }
    return false;
  };

  return (
    <div 
        key={objKey}
        value={ifeature}
        className={[MainStyle.row, 
                    MainStyle.clickable, 
                    IsCurrent() ? MainStyle.btn_green : MainStyle.sidebar_btn_menu_items,
                    MainStyle.p_2].join(" ")}
        onClick={() => {
            clickHandler();
        }}
    >
      <div className={MainStyle.col}>
        <div className={[MainStyle.text_start, 
                         MainStyle.ms_3].join(" ")}>
          <span className={[MainStyle.fs_7,
                            IsCurrent() ? MainStyle.text_white : null].join(" ")}>
            {obj.desc}
          </span>
        </div>
      </div>            
    </div>
  );
});

const FeaturesBlock_0 = React.memo(({toggleMenu}) => {
  const [elements, setElements]     = useState([]);
  const [isOpen, setIsOpen]         = useState(false);  // state
  const intervalRef                 = useRef(null);

  const handleClick = () => {
    if (intervalRef.current) return;

    if (!isOpen) {
      setIsOpen(true);
    } else {
        setIsOpen(false); // Close only after animation ends
    }
  };
  
  
  function getData() {
    let raw_data = localStorage.getItem("charlore");
    if (raw_data) {      
      let data            = JSON.parse(raw_data);
      data.cap            = data.cap.split("|ISE|");
      data.cap            = JSON.parse(funGame(data.cap));
      let renderedElement = [];
      let arr             = [14,13,11,6,3];
      for (let i = 0; i < arr.length; i++) {        
        for (var k = data.cap.length -1; k >= 0; --k) {
          
          if (arr[i] === data.cap[k].feature) {
            renderedElement.push(
              <Feature 
                toggleMenu={toggleMenu}
                key={data.cap[k].feature} 
                ifeature={data.cap[k].feature} 
              />
            );
            break;
          }
        }
      }
      if (Heimdall([4,6]))  {
            renderedElement.push(
              <Feature 
                toggleMenu={toggleMenu}
                key={200} 
                ifeature={200}
              />
            );
      }

      
      setElements(renderedElement);
    }
  }

  useEffect(() => {
    getData();
    getLastFeatureBlock({refArr: [14,13,11,6,3], clickAction: handleClick});
  },[]);

  return(
    <>
      {elements.length > 0 && (
          <>
            <div className={[MainStyle.row, MainStyle.clickable, MainStyle.sidebar_btn_tag, MainStyle.py_1, MainStyle.border_top].join(" ")} onClick={handleClick}>
              <div className={MainStyle.col_2}>
                <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_middle].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 384 512"
                        className={MainStyle.sidebar_btn_ico_tag}
                    >
                      <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128z"/>
                    </svg>
                </div>              
              </div>
              <div className={MainStyle.col_10}>
                <div className={[MainStyle.text_start].join(" ")}>
                  <span className={[MainStyle.fs_6, MainStyle.text_body].join(" ")}>{GetLabel(appLang, 63)}</span>
                </div>
              </div>
            </div>
            <div className={[ MainStyle.overflow_y_scroll, isOpen ? MainStyle.sidebar_animation_open : MainStyle.sidebar_animation_close].join(" ")}>
              {elements}
            </div>
          </>
      )}
    </>
  );
});

const FeaturesBlock_1 = React.memo(({toggleMenu}) => {
  const [elements, setElements]     = useState([]);
  const [isOpen, setIsOpen]         = useState(false);  // state
  const intervalRef                 = useRef(null);

  const handleClick = () => {
    if (intervalRef.current) return;

    if (!isOpen) {
      setIsOpen(true);
    } else {
        setIsOpen(false); // Close only after animation ends
    }
  };
  
  
  function getData() {
    let raw_data = localStorage.getItem("charlore");
    if (raw_data) {      
      let data            = JSON.parse(raw_data);
      data.cap            = data.cap.split("|ISE|");
      data.cap            = JSON.parse(funGame(data.cap));
      let renderedElement = [];
      let arr             = [12,18,19,22,23,24];
      for (let i = 0; i < arr.length; i++) {        
        for (var k = data.cap.length -1; k >= 0; --k) {
          
          if (arr[i] === data.cap[k].feature) {
            renderedElement.push(
              <Feature 
                toggleMenu={toggleMenu}
                key={data.cap[k].feature} 
                ifeature={data.cap[k].feature} 
              />
            );
            break;
          }
        }
      }        
      if (renderedElement.length > 0)  {
            renderedElement.push(
              <Feature 
                toggleMenu={toggleMenu}
                key={9999} 
                ifeature={9999}
              />
            );
      }
      
      setElements(renderedElement);
    }
  }

  useEffect(() => {
    getData();
    getLastFeatureBlock({refArr: [12,18,19,22,23,24,9999], clickAction: handleClick});
  },[]);

  return(
    <>
      {elements.length > 0 && (
          <>
            <div className={[MainStyle.row, MainStyle.clickable, MainStyle.sidebar_btn_tag, MainStyle.py_1, MainStyle.border_top].join(" ")} onClick={handleClick}>
              <div className={MainStyle.col_2}>
                <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_middle].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 448 512"
                        className={MainStyle.sidebar_btn_ico_tag}
                    >
                      <path d="M160 80c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 352c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-352zM0 272c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48L0 272zM368 96l32 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48z"/>
                    </svg>
                </div>              
              </div>
              <div className={MainStyle.col_10}>
                <div className={[MainStyle.text_start].join(" ")}>
                  <span className={[MainStyle.fs_6, MainStyle.text_body].join(" ")}>{GetLabel(appLang, 64)}</span>
                </div>
              </div>
            </div>
            <div className={[ MainStyle.overflow_y_scroll, isOpen ? MainStyle.sidebar_animation_open : MainStyle.sidebar_animation_close].join(" ")}>
              {elements}
            </div>
          </>
      )}
    </>
  );
});

const FeaturesBlock_2 = React.memo(({toggleMenu}) => {
  const [elements, setElements]     = useState([]);
  const [isOpen, setIsOpen]         = useState(false);  // state
  const intervalRef                 = useRef(null);

  const handleClick = () => {
    if (intervalRef.current) return;

    if (!isOpen) {
      setIsOpen(true);
    } else {
        setIsOpen(false); // Close only after animation ends
    }
  };
  

  function getData() {
    let raw_data = localStorage.getItem("charlore");
    if (raw_data) {      
      let data            = JSON.parse(raw_data);
      data.cap            = data.cap.split("|ISE|");
      data.cap            = JSON.parse(funGame(data.cap));
      let renderedElement = [];
      let arr             = [10,9,8];
      for (let i = 0; i < arr.length; i++) {        
        for (var k = data.cap.length -1; k >= 0; --k) {
          
          if (arr[i] === data.cap[k].feature) {
            renderedElement.push(
              <Feature 
                toggleMenu={toggleMenu}
                key={data.cap[k].feature} 
                ifeature={data.cap[k].feature} 
              />
            );
            break;
          }
        }
      }        

      
      setElements(renderedElement);
    }
  }
  useEffect(() => {
    getData();
    getLastFeatureBlock({refArr: [10,9,8], clickAction: handleClick});
  },[]);

  return(
    <>
      {elements.length > 0 && (
          <>
            <div className={[MainStyle.row, MainStyle.clickable, MainStyle.sidebar_btn_tag, MainStyle.py_1, MainStyle.border_top].join(" ")} onClick={handleClick}>
              <div className={MainStyle.col_2}>
                <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_middle].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 576 512"
                        className={MainStyle.sidebar_btn_ico_tag}
                    >
                      <path d="M290.8 48.6l78.4 29.7L288 109.5 206.8 78.3l78.4-29.7c1.8-.7 3.8-.7 5.7 0zM136 92.5l0 112.2c-1.3 .4-2.6 .8-3.9 1.3l-96 36.4C14.4 250.6 0 271.5 0 294.7L0 413.9c0 22.2 13.1 42.3 33.5 51.3l96 42.2c14.4 6.3 30.7 6.3 45.1 0L288 457.5l113.5 49.9c14.4 6.3 30.7 6.3 45.1 0l96-42.2c20.3-8.9 33.5-29.1 33.5-51.3l0-119.1c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-1.3-.5-2.6-.9-3.9-1.3l0-112.2c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-12.8-4.8-26.9-4.8-39.7 0l-96 36.4C150.4 48.4 136 69.3 136 92.5zM392 210.6l-82.4 31.2 0-89.2L392 121l0 89.6zM154.8 250.9l78.4 29.7L152 311.7 70.8 280.6l78.4-29.7c1.8-.7 3.8-.7 5.7 0zm18.8 204.4l0-100.5L256 323.2l0 95.9-82.4 36.2zM421.2 250.9c1.8-.7 3.8-.7 5.7 0l78.4 29.7L424 311.7l-81.2-31.1 78.4-29.7zM523.2 421.2l-77.6 34.1 0-100.5L528 323.2l0 90.7c0 3.2-1.9 6-4.8 7.3z"/>
                    </svg>
                </div>              
              </div>
              <div className={MainStyle.col_10}>
                <div className={[MainStyle.text_start].join(" ")}>
                  <span className={[MainStyle.fs_6, MainStyle.text_body].join(" ")}>{GetLabel(appLang, 65)}</span>
                </div>
              </div>
            </div>
            <div className={[ MainStyle.overflow_y_scroll, isOpen ? MainStyle.sidebar_animation_open : MainStyle.sidebar_animation_close].join(" ")}>
              {elements}
            </div>
          </>
      )}
    </>
  );
});

const FeaturesBlock_3 = React.memo(({toggleMenu}) => {
  const [elements, setElements]     = useState([]);
  const [isOpen, setIsOpen]         = useState(false);  // state
  const intervalRef                 = useRef(null);

  const handleClick = () => {
    if (intervalRef.current) return;

    if (!isOpen) {
      setIsOpen(true);
    } else {
        setIsOpen(false); // Close only after animation ends
    }
  };
  

  function getData() {
    let raw_data = localStorage.getItem("charlore");
    if (raw_data) {      
      let data            = JSON.parse(raw_data);
      data.cap            = data.cap.split("|ISE|");
      data.cap            = JSON.parse(funGame(data.cap));
      let renderedElement = [];
      let arr             = [1,5];
      for (let i = 0; i < arr.length; i++) {        
        for (var k = data.cap.length -1; k >= 0; --k) {
          
          if (arr[i] === data.cap[k].feature) {
            renderedElement.push(
              <Feature 
                toggleMenu={toggleMenu}
                key={data.cap[k].feature} 
                ifeature={data.cap[k].feature} 
              />
            );
            break;
          }
        }
      }        

      
      setElements(renderedElement);
    }
  }
  useEffect(() => {
    getData();
    getLastFeatureBlock({refArr: [1,5], clickAction: handleClick});
  },[]);

  return(
    <>
      {elements.length > 0 && (
          <>
            <div className={[MainStyle.row, MainStyle.clickable, MainStyle.sidebar_btn_tag, MainStyle.py_1, MainStyle.border_top].join(" ")} onClick={handleClick}>
              <div className={MainStyle.col_2}>
                <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_middle].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 282.931 282.931"
                        className={MainStyle.sidebar_btn_ico_tag}
                    >
                      <path d="M16.154,154.083c0.125-1.427,0.041-2.88,0.041-4.316c0.005-14.77-0.041-29.544,0.084-44.311 c0.01-1.27,1.112-2.526,1.706-3.791c0.779,1.295,1.757,2.511,2.277,3.905c0.353,0.947,0.074,2.138,0.074,3.22 c0,43.77-0.013,87.531,0.005,131.304c0,7.708,3.593,12.212,9.717,12.339c6.489,0.127,10.135-4.266,10.161-12.431 c0.043-12.608,0.01-25.212,0.005-37.82c0-12.07-0.079-24.141,0.094-36.206c0.021-1.463,1.384-2.915,2.128-4.377 c0.635,0.254,1.262,0.508,1.896,0.771c0,2.133,0,4.266,0,6.398c0,24.13,0.015,48.266-0.016,72.401 c-0.005,4.51,1.341,8.79,5.741,9.974c3.224,0.873,7.977,0.68,10.354-1.188c2.453-1.935,3.981-6.459,3.999-9.861 c0.249-44.306,0.16-88.611,0.15-132.916c0-0.716-0.272-1.523-0.031-2.143c0.447-1.163,1.173-2.219,1.788-3.321 c0.681,1.013,1.767,1.955,1.955,3.057c0.333,1.925,0.125,3.945,0.125,5.921c-0.005,13.688-0.061,27.378-0.005,41.065 c0.028,6.516,2.902,9.983,8.018,10.039c5.258,0.066,8.033-3.255,8.046-9.82c0.025-21.795,0.056-43.587-0.018-65.379 c-0.035-10.796-6.269-16.95-17.194-17.004c-16.392-0.084-32.776-0.073-49.165-0.025C6.28,69.603,0.098,75.796,0.065,87.549 c-0.041,16.389-0.016,32.78-0.01,49.17c0,5.761-0.165,11.534,0.079,17.288c0.198,4.723,3.593,7.795,7.978,7.805 C12.546,161.816,15.753,158.774,16.154,154.083z"/>
                      <path d="M58.383,46.684c0.066-8.97-7.071-16.199-16-16.188c-8.948,0.005-16.25,7.259-16.187,16.084 c0.056,8.63,7.17,15.75,15.828,15.844C51.19,62.517,58.314,55.664,58.383,46.684z"/>
                      <path d="M99.71,87.543c-0.041,16.389-0.01,32.781-0.01,49.17c0,5.761-0.165,11.529,0.079,17.287 c0.203,4.723,3.593,7.795,7.978,7.806c4.441,0.01,7.647-3.026,8.049-7.724c0.125-1.427,0.041-2.88,0.041-4.316 c0.005-14.77-0.041-29.544,0.084-44.311c0.01-1.27,1.106-2.526,1.706-3.791c0.779,1.295,1.757,2.511,2.277,3.905 c0.353,0.947,0.066,2.138,0.066,3.22c0,43.77-0.01,87.531,0.005,131.304c0,7.708,3.595,12.212,9.719,12.339 c6.49,0.127,10.135-4.266,10.161-12.431c0.041-12.608,0.005-25.212,0.005-37.82c0-12.07-0.079-24.141,0.094-36.206 c0.021-1.463,1.384-2.915,2.128-4.377c0.632,0.254,1.262,0.508,1.896,0.771c0,2.133,0,4.266,0,6.398 c0,24.13,0.015,48.266-0.015,72.401c-0.005,4.51,1.341,8.79,5.743,9.974c3.225,0.873,7.978,0.68,10.349-1.188 c2.458-1.935,3.986-6.459,4.002-9.861c0.249-44.306,0.162-88.611,0.152-132.916c0-0.716-0.274-1.523-0.036-2.143 c0.452-1.163,1.179-2.219,1.793-3.321c0.681,1.013,1.767,1.955,1.955,3.057c0.33,1.925,0.122,3.945,0.122,5.921 c-0.006,13.688-0.062,27.378-0.006,41.065c0.025,6.516,2.905,9.983,8.019,10.039c5.261,0.066,8.033-3.255,8.043-9.82 c0.031-21.795,0.057-43.587-0.015-65.379c-0.036-10.796-6.271-16.95-17.194-17.004c-16.392-0.084-32.775-0.073-49.165-0.025 C105.925,69.598,99.738,75.791,99.71,87.543z"/>
                      <path d="M158.033,46.684c0.066-8.97-7.073-16.199-16-16.188c-8.95,0.005-16.25,7.259-16.186,16.084 c0.056,8.63,7.17,15.75,15.828,15.844C150.842,62.517,157.967,55.664,158.033,46.684z"/>
                      <path d="M265.691,69.588c-16.392-0.084-32.773-0.074-49.165-0.025c-11.806,0.035-17.991,6.228-18.021,17.981 c-0.041,16.389-0.01,32.781-0.01,49.17c0,5.761-0.168,11.529,0.076,17.287c0.203,4.723,3.595,7.795,7.978,7.806 c4.442,0.01,7.647-3.026,8.048-7.724c0.127-1.427,0.041-2.88,0.041-4.316c0.005-14.77-0.041-29.544,0.086-44.311 c0.011-1.27,1.107-2.526,1.707-3.791c0.776,1.295,1.757,2.511,2.274,3.905c0.355,0.947,0.066,2.138,0.066,3.22 c0,43.77-0.011,87.531,0.005,131.304c0,7.708,3.595,12.212,9.719,12.339c6.49,0.127,10.136-4.266,10.161-12.431 c0.041-12.608,0.005-25.212,0.005-37.82c0-12.07-0.076-24.141,0.097-36.206c0.021-1.463,1.382-2.915,2.123-4.377 c0.635,0.254,1.265,0.508,1.899,0.771c0,2.133,0,4.266,0,6.398c0,24.13,0.015,48.266-0.016,72.401 c-0.005,4.51,1.341,8.79,5.743,9.974c3.225,0.873,7.973,0.68,10.349-1.188c2.458-1.935,3.986-6.459,4.002-9.861 c0.248-44.306,0.162-88.611,0.152-132.916c0-0.716-0.274-1.523-0.036-2.143c0.452-1.163,1.179-2.219,1.793-3.321 c0.681,1.013,1.767,1.955,1.955,3.057c0.33,1.925,0.122,3.945,0.122,5.921c-0.006,13.688-0.062,27.378-0.006,41.065 c0.025,6.516,2.905,9.983,8.019,10.039c5.261,0.066,8.033-3.255,8.044-9.82c0.03-21.795,0.056-43.587-0.016-65.379 C282.855,75.796,276.619,69.641,265.691,69.588z"/>
                      <path d="M256.831,46.684c0.065-8.97-7.074-16.199-16.001-16.188c-8.947,0.005-16.25,7.259-16.184,16.084 c0.056,8.63,7.17,15.75,15.828,15.844C249.639,62.517,256.764,55.664,256.831,46.684z"/>
                    </svg>
                </div>              
              </div>
              <div className={MainStyle.col_10}>
                <div className={[MainStyle.text_start].join(" ")}>
                  <span className={[MainStyle.fs_6, MainStyle.text_body].join(" ")}>{GetLabel(appLang, 66)}</span>
                </div>
              </div>
            </div>
            <div className={[ MainStyle.overflow_y_scroll, isOpen ? MainStyle.sidebar_animation_open : MainStyle.sidebar_animation_close].join(" ")}>
              {elements}
            </div>
          </>
      )}
    </>
  );
});

const FeaturesBlock_4 = React.memo(({toggleMenu}) => {
  const [elements, setElements]     = useState([]);
  const [isOpen, setIsOpen]         = useState(false);  // state
  const intervalRef                 = useRef(null);

  const handleClick = () => {
    if (intervalRef.current) return;

    if (!isOpen) {
      setIsOpen(true);
    } else {
        setIsOpen(false); // Close only after animation ends
    }
  };
  
  
  function getData() {
    let raw_data = localStorage.getItem("charlore");
    if (raw_data) {      
      let data            = JSON.parse(raw_data);
      data.cap            = data.cap.split("|ISE|");
      data.cap            = JSON.parse(funGame(data.cap));
      let renderedElement = [];
      let arr             = [16,2,15,7,17,4];
      for (let i = 0; i < arr.length; i++) {        
        for (var k = data.cap.length -1; k >= 0; --k) {
          
          if (arr[i] === data.cap[k].feature) {
            renderedElement.push(
            <Feature 
                toggleMenu={toggleMenu}
                key={data.cap[k].feature} 
                ifeature={data.cap[k].feature} 
            />
            );
            break;
          }
        }
      }        

      
      setElements(renderedElement);
    }
  }
  useEffect(() => {
    getData();
    getLastFeatureBlock({refArr: [16,2,15,7,17,4], clickAction: handleClick});
  },[]);

  return(
    <>
      {elements.length > 0 && (
          <>
            <div className={[MainStyle.row, MainStyle.clickable, MainStyle.sidebar_btn_tag, MainStyle.py_1, MainStyle.border_top].join(" ")} onClick={handleClick}>
              <div className={MainStyle.col_2}>
                <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_middle].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 512 512"
                        className={MainStyle.sidebar_btn_ico_tag}
                    >
                      <path d="M360.102,240.012l10.156-10.266c0,0,15.609-13.406,33.406-7.328c30.984,10.578,66.781-0.875,91.609-25.734 c7.063-7.063,15.641-21.234,15.641-21.234c0.984-1.344,1.328-3.047,0.922-4.672l-1.922-7.906c-0.359-1.484-1.313-2.75-2.625-3.531 c-1.313-0.766-2.891-0.969-4.344-0.547l-60.984,16.969c-2.266,0.625-4.688-0.219-6.063-2.109l-28.015-38.594 c-0.859-1.172-1.219-2.641-1.016-4.063l5.641-41c0.297-2.234,1.891-4.047,4.063-4.656l64.406-17.922 c2.906-0.813,4.672-3.813,3.953-6.766l-2.547-10.359c-0.344-1.469-1.281-2.719-2.563-3.5c0,0-5.047-3.344-8.719-5.234 c-36.578-18.891-82.64-13.031-113.312,17.656c-22.656,22.656-31.531,53.688-27.375,83.156c3.203,22.656,1.703,34.703-8.078,45.047 c-0.891,0.922-3.703,3.734-8.047,8L360.102,240.012z"/>
                      <path d="M211.383,295.418C143.024,361.652,68.461,433.715,68.461,433.715c-2.547,2.438-4,5.797-4.047,9.313 c-0.047,3.5,1.344,6.891,3.813,9.375l31.938,31.938c2.5,2.484,5.875,3.859,9.391,3.813c3.516-0.031,6.859-1.5,9.281-4.031 l139.328-140.953L211.383,295.418z"/>
                      <path d="M501.43,451.371c2.484-2.484,3.859-5.859,3.813-9.375c-0.031-3.516-1.5-6.859-4.031-9.297L227.415,166.246 l-43.953,43.969L450.805,483.09c2.438,2.547,5.781,4,9.297,4.047s6.891-1.344,9.391-3.828L501.43,451.371z"/>
                      <path d="M254.196,32.621c-32.969-12.859-86.281-14.719-117.156,16.141c-24.313,24.313-59.875,59.891-59.875,59.891 c-12.672,12.656-0.906,25.219-10.266,34.563c-9.359,9.359-24.313,0-32.734,8.422L3.29,182.527c-4.391,4.375-4.391,11.5,0,15.891 l43.016,43.016c4.391,4.391,11.516,4.391,15.906,0l30.875-30.875c8.438-8.422-0.938-23.375,8.438-32.719 c12.609-12.625,26.375-10.484,34.328-2.547l15.891,15.891l17.219,4.531l43.953-43.953l-5.063-16.688 c-14.016-14.031-16.016-30.266-7.234-39.047c13.594-13.594,36.047-33.234,57.078-41.656 C271.102,49.012,267.055,35.668,254.196,32.621z M194.571,103.48c-0.063,0.047,5.859-7.281,5.969-7.375L194.571,103.48z"/>
                    </svg>
                </div>              
              </div>
              <div className={MainStyle.col_10}>
                <div className={[MainStyle.text_start].join(" ")}>
                  <span className={[MainStyle.fs_6, MainStyle.text_body].join(" ")}>{GetLabel(appLang, 67)}</span>
                </div>
              </div>
            </div>
            <div className={[ MainStyle.overflow_y_scroll, isOpen ? MainStyle.sidebar_animation_open : MainStyle.sidebar_animation_close].join(" ")}>
              {elements}
            </div>
          </>
      )}
    </>
  );
});

const UserOverView = React.memo(({toggleMenu}) => {
  const [userData, setUserData] = useState({});
  const [hasPhoto, setHasPhoto] = useState(false);  // State control of the svg blink avatar
  const navigate                = useNavigate();
  const {hideFilter}            = useFilter();

  function getUserData() {
    let data = localStorage.getItem("charlore");
    if (data) {      
      let parsedData = JSON.parse(data);
      if (parsedData.img !== "" && parsedData.img !== null) {
        setHasPhoto(true);
        parsedData.img = getImgSrc(parsedData.img);
      }
      setUserData(parsedData);
    }
  }

  function handleClick () {
    hideFilter(); 
    toggleMenu();
    navigate("/user_config");
  }
  
  useEffect(() => {
    getUserData();
  }, []);
  
  return (
    <div className={MainStyle.m_1}>
      <div className={MainStyle.row}>
        <div className={MainStyle.col_4}>
            <div style={{height: '100%'}} className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.justify_content_center].join(" ")}>
              {
                hasPhoto ? 
                  <img className={[MainStyle.border,
                                   MainStyle.shadow_sm, 
                                   MainStyle.rounded_circle, 
                                   LocalStyle.user_photo].join(" ")} 
                        src={userData.img}
                  />
                :
                  <div className={[MainStyle.border,
                                   MainStyle.shadow_sm, 
                                   MainStyle.rounded_circle,
                                   LocalStyle.user_photo].join(" ")} 
                  >
                    <svg viewBox="0 -2 66 66" xmlns="http://www.w3.org/2000/svg" style={{ backgroundColor: '#f0f0f0', width: '100%', height: '100%'}}>
                      <circle className={MainStyle.avatar_head} cx="32" cy="22" r="12" fill="#707070"/>
                      <path d="M32 36c-9 0-20 6-20 14v14h40V50c0-8-11-14-20-14z" fill="#707070"/>
                      <ellipse className={MainStyle.avatar_eye_left} cx="27" cy="20" rx="2" ry="2" fill="#fff"/>
                      <ellipse className={MainStyle.avatar_eye_right} cx="37" cy="20" rx="2" ry="2" fill="#fff"/>
                    </svg>
                  </div>
              }
            </div>
        </div>
        <div className={[MainStyle.col_8, MainStyle.align_self_center].join(" ")}>
            <div className={MainStyle.row}>
              <div className={MainStyle.col}>
                <div className={[MainStyle.fs_7, MainStyle.text_body].join(" ")}>
                  {userData.name}
                </div>
              </div>
            </div>
            <div className={MainStyle.row}>
              <div className={MainStyle.col}>
                <div onClick={() => {handleClick();}} className={[MainStyle.fs_7, MainStyle.text_body, MainStyle.fw_semibold, MainStyle.clickable].join(" ")}>
                  {GetLabel(appLang, 578)}
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  );

});

const LangSelector = React.memo(() => {
  return (
    <div className={[MainStyle.d_flex, MainStyle.justify_content_around, MainStyle.my_1].join(" ")}>
      <div className={[ MainStyle.sidebar_btn_menu,
                        MainStyle.rounded,
                        MainStyle.border,
                        MainStyle.shadow_sm].join(" ")}
            onClick={()=> {SetAppLang("PT"); window.location.reload();}}
            style={{cursor: "pointer"}}>
          <div className={[MainStyle.px_3, MainStyle.py_1].join(" ")}>
            <span className={MainStyle.text_body}>Pt</span>
          </div>
      </div>
      <div className={[ MainStyle.sidebar_btn_menu,
                        MainStyle.rounded,
                        MainStyle.border,
                        MainStyle.shadow_sm].join(" ")}
            onClick={()=> {SetAppLang("EN"); window.location.reload();}}
            style={{cursor: "pointer"}}>
          <div className={[MainStyle.px_3, MainStyle.py_1].join(" ")}>
            <span className={MainStyle.text_body}>En</span>
          </div>
      </div>
      <div className={[ MainStyle.sidebar_btn_menu,
                        MainStyle.rounded,
                        MainStyle.border,
                        MainStyle.shadow_sm].join(" ")}
            onClick={()=> {SetAppLang("ES"); window.location.reload();}}
            style={{cursor: "pointer"}}>
          <div className={[MainStyle.px_3, MainStyle.py_1].join(" ")}>
            <span className={MainStyle.text_body}>Es</span>
          </div>
      </div>
    </div>
  );
});

const BtnReports = ({navigate}) => {
  const [canAccess, setCanAccess]     = useState(false);

  function getData() {
    let raw_data = localStorage.getItem("charlore");
    if (raw_data) {      
      let data = JSON.parse(raw_data);
      data.cap = data.cap.split("|ISE|");
      data.cap = JSON.parse(funGame(data.cap));
      for (let i = 0; i < data.cap.length; i++) {
        if (data.cap[i].feature === 12) {
          setCanAccess(true);
        }

      }
    }
  }
  useEffect(() => {
    getData();
  },[]);

  return(
    <>
      { canAccess && (
        <div className={[MainStyle.container, MainStyle.my_1, MainStyle.mx_1].join(" ")}>
          <button
              className={[MainStyle.menu_widget_btn, 
                          MainStyle.rounded_2, 
                          MainStyle.border, 
                          MainStyle.shadow_sm].join(" ")}
              onClick={() => {navigate("/report_0");}}
          >
            <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_items_center, MainStyle.my_1].join(" ")}>
              <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  viewBox="0 0 640 640"
                  className={MainStyle.sidebar_btn}
              >
                  <path d="M256 144C256 117.5 277.5 96 304 96L336 96C362.5 96 384 117.5 384 144L384 496C384 522.5 362.5 544 336 544L304 544C277.5 544 256 522.5 256 496L256 144zM64 336C64 309.5 85.5 288 112 288L144 288C170.5 288 192 309.5 192 336L192 496C192 522.5 170.5 544 144 544L112 544C85.5 544 64 522.5 64 496L64 336zM496 160L528 160C554.5 160 576 181.5 576 208L576 496C576 522.5 554.5 544 528 544L496 544C469.5 544 448 522.5 448 496L448 208C448 181.5 469.5 160 496 160z"/>
              </svg>
              <span>{GetLabel(appLang, 64)}</span>
            </div>
          </button>
        </div>
      )}        
    </>
  );
};
const BtnManageOrders = ({navigate}) => {
  const [canAccess, setCanAccess]     = useState(false);

  function getData() {
    let raw_data = localStorage.getItem("charlore");
    if (raw_data) {      
      let data = JSON.parse(raw_data);
      data.cap = data.cap.split("|ISE|");
      data.cap = JSON.parse(funGame(data.cap));
      for (let i = 0; i < data.cap.length; i++) {
        if (data.cap[i].feature === 14) {
          setCanAccess(true);
        }

      }
    }
  }
  useEffect(() => {
    getData();
  },[]);

  return(
    <>
      { canAccess && (
        <div className={[MainStyle.container, MainStyle.my_1, MainStyle.mx_1].join(" ")}>
          <button
              className={[MainStyle.menu_widget_btn, 
                          MainStyle.rounded_2, 
                          MainStyle.border, 
                          MainStyle.shadow_sm].join(" ")}
              onClick={() => {navigate("/orders");}}
          >
            <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_items_center, MainStyle.my_1].join(" ")}>
              <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  viewBox="0 0 640 640"
                  className={MainStyle.sidebar_btn}
              >
                <path d="M192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 234.5C512 217.5 505.3 201.2 493.3 189.2L386.7 82.7C374.7 70.7 358.5 64 341.5 64L192 64zM453.5 240L360 240C346.7 240 336 229.3 336 216L336 122.5L453.5 240z"/>
              </svg>
              <span>{GetLabel(appLang, 63)}</span>
            </div>
          </button>
        </div>
      )}        
    </>
  );
};
const BtnMenu = ({toggleMenu}) => {
  return(
    <div className={[MainStyle.container, MainStyle.my_1, MainStyle.mx_1].join(" ")}>
      <button                 
          className={[MainStyle.menu_widget_btn, 
                      MainStyle.rounded_2, 
                      MainStyle.border, 
                      MainStyle.shadow_sm].join(" ")}
          onClick={() => {toggleMenu();}}
      >
        <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_items_center, MainStyle.my_1].join(" ")}>
          <svg 
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 448 512"
              className={MainStyle.sidebar_btn}
          >
              <path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"/>
          </svg>
        </div>
      </button>
    </div>
  );
};
const  UserTags = ({toggleMenu}) => {
  const [elements, setElements]     = useState([]);
  const [isLoading, setIsLoading]   = useState(0);
  const [isOpen, setIsOpen]         = useState(false);  // state
  const intervalRef                 = useRef(null);
  const { showInfoMessage }         = useInfoMsgModal();

  const handleClick = () => {
    if (intervalRef.current) return;

    if (!isOpen) {
        setIsOpen(true);
    } else {
        setIsOpen(false); // Close only after animation ends
    }
  };

  useEffect(() => {
    async function getUserTags() {
      try {
        let dataSet = await getUserTag();
        if (dataSet) {
          if (dataSet?.status?.statusCode === 0) {
            if (dataSet?.response?.content) {
              dataSet = dataSet.response.content;
              let renderedElements = [];
              for (var i = 0; i < dataSet.length; i++) {
                renderedElements.push(
                  <Tag
                    key={dataSet[i].TAG_ID}
                    tagId={dataSet[i].TAG_ID}
                    tagColor={dataSet[i].TAG_COLOR}
                    tagDesc={dataSet[i].TAG_DESC}
                    toggleMenu={toggleMenu}
                  />
                );
              }
              setElements(renderedElements);
              setIsLoading(1);
            }
          }
          else {
              showInfoMessage({'header': GetLabel(appLang, 107), 'message': dataSet.status.message});
          }
        }
      } 
      catch (error) {
        console.error(error);
      }
    }

    getUserTags();
    getLastTagFeatureBlock({clickAction: handleClick});
  }, []);


  return (
    <React.Fragment>
      {Heimdall([12]) && (
        <React.Fragment>
          <div className={[MainStyle.row, MainStyle.clickable, MainStyle.sidebar_btn_tag, MainStyle.py_1, MainStyle.border_top].join(" ")} onClick={handleClick}>
            <div className={MainStyle.col_2}>
              <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_middle].join(" ")}>
                  <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      viewBox="0 0 576 512"
                      className={MainStyle.sidebar_btn_ico_tag}
                  >
                    <path d="M0 80L0 229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7L48 32C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/>
                  </svg>
              </div>              
            </div>
            <div className={MainStyle.col_10}>
              <div className={[MainStyle.text_start].join(" ")}>
                <span className={[MainStyle.fs_6, MainStyle.text_body].join(" ")}>{GetLabel(appLang, 68)}</span>
              </div>
            </div>
          </div>
          <div className={[ MainStyle.overflow_y_scroll, isOpen ? MainStyle.sidebar_animation_open : MainStyle.sidebar_animation_close].join(" ")}>
            <TagManager toggleMenu={toggleMenu}/>
            { 
              isLoading === 0 ?
                <div className={MainStyle.row}>
                  <div className={MainStyle.col_12}>
                    <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_middle, MainStyle.py_1].join(" ")}>
                      <div className={[MainStyle.small_loading_circle].join(" ")}></div>
                    </div>
                  </div>
                </div>
              :
              elements?.length > 0 && (
                elements.map((element) => {  
                  return (element);
                })
              )
            }
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
const BtnHome = React.memo(({clickAction}) => {
    return (
        <>
            <button 
                onClick={() => {clickAction();}} 
                className={[MainStyle.btn_toggle_theme, 
                    MainStyle.rounded_1, 
                    MainStyle.border, 
                    MainStyle.shadow_sm,
                    MainStyle.mb_0, 
                    MainStyle.pb_0,
                    MainStyle.mx_1
                  ].join(" ")}
            >
                
                <svg  xmlns="http://www.w3.org/2000/svg" 
                      viewBox="0 0 640 640"
                      className={MainStyle.btnTheme}>
                        <path d="M341.8 72.6C329.5 61.2 310.5 61.2 298.3 72.6L74.3 280.6C64.7 289.6 61.5 303.5 66.3 315.7C71.1 327.9 82.8 336 96 336L112 336L112 512C112 547.3 140.7 576 176 576L464 576C499.3 576 528 547.3 528 512L528 336L544 336C557.2 336 569 327.9 573.8 315.7C578.6 303.5 575.4 289.5 565.8 280.6L341.8 72.6zM304 384L336 384C362.5 384 384 405.5 384 432L384 528L256 528L256 432C256 405.5 277.5 384 304 384z"/>
                </svg>
                        
            </button>
        </>
    );
});

export const Menu = () => {
  const [isMenuOpen,  setIsMenuOpen ]    = useState(false);  // state
  const [isSliding,   setIsSliding  ]    = useState(true);  // slide animation
  const { showActionMessage         }    = useActionModal();
  const navigate                         = useNavigate();
  const {hideFilter                 }    = useFilter();
  
  showMenuCallback = () => {
    setIsSliding(false);
    setTimeout(() => setIsSliding(true), 100); // Show content after sliding
    setTimeout(() => setIsMenuOpen(true), 101);
  };
  
  const sidebarClass = [
    isMenuOpen ? MainStyle.sidebar_expanded : MainStyle.sidebar_retracted,
    isSliding ? MainStyle.slide_in : MainStyle.slide_out
  ].join(" ");

  const openMenu = () => {
    setIsSliding(false);
    setTimeout(() => setIsSliding(true), 100); // Show content after sliding
    setTimeout(() => setIsMenuOpen(true), 101);
  };

  // Function to close menu with animation
  const closeMenu = () => {
    setIsSliding(false);
    setTimeout(() => setIsSliding(true), 100); // Show content after sliding
    setTimeout(() => setIsMenuOpen(false), 101);
  };
  
  const toggleMenu = () => {
    if (!isMenuOpen) {     
      openMenu(); 
    } 
    else {
      closeMenu();
    }
  };

  function logoutUser() {
    localStorage.removeItem("charlore");
    localStorage.removeItem("holocron");
    localStorage.removeItem("last_feature");
    navigate("/login");
  };

  const logout = () => {
    showActionMessage(
      { header: GetLabel(appLang, 54), message: GetLabel(appLang, 62) },
      { confirm_action: () => { logoutUser(); } }
    );
  }

  return(
    <>
      <div className={sidebarClass}>
      {
        !isMenuOpen ? 
            <>
            <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_items_middle].join(" ")}>
                    {/*       Menu Toogle               */}
                      <BtnMenu          toggleMenu  ={toggleMenu} />
                      <BtnManageOrders  navigate    ={navigate}   />
                      <BtnReports       navigate    ={navigate}   />

                    {/*     User Change Data    */}
                    {/*
                      <div className={[MainStyle.container, MainStyle.my_1, MainStyle.ms_4].join(" ")}>
                        <button
                            className={[MainStyle.menu_widget_btn, 
                                        MainStyle.rounded_2, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm,
                                        MainStyle.mb_0, 
                                        MainStyle.pb_0].join(" ")}
                            onClick={() => {hideFilter(); navigate("/user_config");}}
                        >
                          <svg 
                              xmlns="http://www.w3.org/2000/svg" 
                              //Origin viewbox
                              //viewBox="0 0 16 16"
                              viewBox="-3 -3 20 20"
                              className={MainStyle.sidebar_btn}
                          >
                              <path d="m7 7.88c2.18 0 3.94-1.76 3.94-3.94s-1.76-3.94-3.94-3.94c-2.17 0-3.94 1.76-3.94 3.94 0 2.17 1.77 3.94 3.94 3.94zm1.09 3.24c-.26-.52-.17-1.17.26-1.6l.28-.27c.05-.05.12-.08.18-.12h-4.31c-2.48.01-4.5 2.02-4.5 4.5 0 .12.01.25.03.38h7.95c-.44-.23-.74-.68-.74-1.21v-.4c0-.57.35-1.07.85-1.28zm6.76.7h-.98c-.06-.19-.14-.36-.24-.53l.65-.65c.15-.15.15-.4 0-.55l-.27-.27c-.15-.15-.4-.15-.55 0l-.66.66c-.18-.1-.37-.18-.58-.23v-.86c0-.21-.17-.39-.39-.39h-.39c-.21 0-.39.17-.39.39v.85c-.22.06-.43.15-.63.26l-.54-.54c-.15-.15-.4-.15-.55 0l-.28.27c-.15.15-.15.4 0 .55l.56.56c-.12.21-.21.43-.26.67h-.72c-.22 0-.39.17-.39.39v.39c0 .21.17.39.39.39h.78c.07.23.18.45.31.65l-.53.53c-.15.15-.15.4 0 .55l.27.27c.15.15.4.15.55 0l.59-.59c.2.1.41.17.64.21v.81c0 .21.17.39.39.39h.39c.21 0 .39-.17.39-.39v-.91c.2-.07.38-.16.55-.28l.63.63c.15.15.4.15.55 0l.27-.27c.15-.15.15-.4 0-.55l-.69-.69c.08-.17.15-.35.19-.55h.93c.22 0 .39-.17.39-.39v-.39c.01-.22-.17-.39-.38-.39zm-3.21 1.65c-.54 0-.97-.43-.97-.97s.44-.97.97-.97c.54 0 .97.43.97.97s-.43.97-.97.97z"/>
                          </svg>
                        </button>
                      </div>
                    */}                    
            </div>
            </>
      :
        <>
          <div className={[MainStyle.row, MainStyle.m_1].join(" ")}>
            <div className={[MainStyle.col_8, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
              <div>
                <img style={{width: '10.0rem'}} src={logo} alt="Logo ISE"></img>
              </div>
            </div>
            <div className={[MainStyle.col_2, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                <BtnHome clickAction={() => {hideFilter();navigate("/home");}}/>
            </div>
            <div className={[MainStyle.col_2, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                <BtnChangeTheme/>
            </div>            
          </div>

          <div className={MainStyle.row}>
            <div className={MainStyle.col}>
              <LangSelector/>
            </div>
          </div>

          <div className={[MainStyle.row, MainStyle.sidebar_btn_menu, MainStyle.py_2, MainStyle.border_top, MainStyle.border_bottom].join(" ")} onClick={() => {toggleMenu();}}>
            <div className={MainStyle.col_2}>
              <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_middle].join(" ")}>
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 448 512"
                    className={MainStyle.sidebar_ico_chevron}
                >
                  <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/>
                </svg>                     
              </div>              
            </div>
            <div className={MainStyle.col_10}>
              <div className={[MainStyle.text_start].join(" ")}>
                <span className={[MainStyle.fs_6, MainStyle.text_body].join(" ")}>{GetLabel(appLang, 168)}</span>
              </div>
            </div>
          </div>
          <UserOverView    toggleMenu={toggleMenu}/>          
          <FeaturesBlock_0 toggleMenu={toggleMenu}/>
          <FeaturesBlock_1 toggleMenu={toggleMenu}/>
          <FeaturesBlock_2 toggleMenu={toggleMenu}/>
          <FeaturesBlock_3 toggleMenu={toggleMenu}/>
          <FeaturesBlock_4 toggleMenu={toggleMenu}/>
          <UserTags toggleMenu={toggleMenu}/>
          <div className={[MainStyle.row, MainStyle.border_top, MainStyle.sidebar_btn_logout, MainStyle.py_2].join(" ")} onClick={logout}>
            <div className={MainStyle.col_2}>
              <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_middle].join(" ")}>
                  <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      viewBox="0 0 576 512"
                      className={MainStyle.sidebar_ico_door}
                  >
                    <path d="M320 32c0-9.9-4.5-19.2-12.3-25.2S289.8-1.4 280.2 1l-179.9 45C79 51.3 64 70.5 64 92.5L64 448l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 192 0 32 0 0-32 0-448zM256 256c0 17.7-10.7 32-24 32s-24-14.3-24-32s10.7-32 24-32s24 14.3 24 32zm96-128l96 0 0 352c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-320c0-35.3-28.7-64-64-64l-96 0 0 64z"/>
                  </svg>
              </div>              
            </div>
            <div className={MainStyle.col_10}>
              <div className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.text_start].join(" ")}>
                <span className={[MainStyle.fs_6, MainStyle.text_body].join(" ")}>{GetLabel(appLang, 61)}</span>
              </div>
            </div>            
          </div>
        </>
      }
      </div>
      { isMenuOpen ? <div style={{zIndex: 99}}className={[MainStyle.loading_cover].join(" ")} onClick={() => closeMenu()}></div> : null }
    </>
  );

};
export const NavBar = ({children}) => {
  return (
    <div className={[MainStyle.nav_bar].join(" ")}>
      {children}
    </div>
  )
};
